export default {
  ApiClientManagementTitle: 'API Client Management',
  buttonNewApiClient: 'เพิ่ม API Client',
  clientID: 'Client ID',
  clientName: 'ชื่อลูกค้า',
  contactEmail: 'อีเมล',
  scopes: 'Scopes',
  ipAdress: 'ที่อยู่ IP',
  status: 'สถานะ',
  expireDate: 'วันหมดดอายุ',
  callbackEndpoint: 'Callback Endpoint',
  authSecret: 'Auth Secret',
  authType: 'Auth Type',
  createdAt: 'วันที่สร้าง',
  actions: 'การกระทำ',
  confirmResetClientSecret: 'คุณแน่ใจหรือไม่ว่าต้องการรีเซ็ตรหัสลับของลูกค้านี้?',
  resetSuccess: 'รีเซ็ตรหัสลับของลูกค้าเรียบร้อยแล้ว',
  confirmDeleteClient: 'คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลลูกค้านี้?',
  deleteSuccess: 'ลบข้อมูลลูกค้าเรียบร้อยแล้ว',
  buttonEditApiClient: 'แก้ไข API Client',
  clientCreate: 'Client Created'

}
